import Vue from 'vue';
import pdfjsLib from 'pdfjs-dist';

export default Vue.extend({
  name: 'makePdf',

  methods: {
    // 製作pdf
    async $_makePdf(pdfData) {
      console.log('makePdf');
      const pdfjs = await import('pdfjs-dist/build/pdf');
      const pdfjsWorker = await import('pdfjs-dist/build/pdf.worker.entry');
      pdfjs.workerSrc = pdfjsWorker;
      $('#pdfPreviewer').empty();
      pdfjsLib.getDocument({ data: pdfData }).then((pdf) => {
        const pageMap = new Map();
        for (let pageNum = 1; pageNum <= pdf.numPages; pageNum += 1) {
          pdf.getPage(pageNum).then((page) => {
            const scale = 3;
            const viewport = page.getViewport(scale);
            const canvas = document.createElement('canvas');
            const context = canvas.getContext('2d');
            canvas.height = viewport.height;
            canvas.width = viewport.width;
            canvas.style.width = `${Math.floor(viewport.width / scale)}pt`;
            canvas.style.height = `${Math.floor(viewport.height / scale)}pt`;
            console.log(viewport.width, ' / ', scale);
            console.log(viewport.width / scale);
            console.log(viewport.height, ' / ', scale);
            console.log(viewport.height / scale);
            context.globalAlpha = 0;
            const renderContext = { canvasContext: context, viewport };
            page.render(renderContext);
            const pdfIn = canvas;
            pageMap.set(page.pageIndex, pdfIn);
            // console.log(page.pageIndex, canvas);
            console.log(pageNum, pageMap.size);
            for (let index = 0; index < pageMap.size; index += 1) {
              console.log('111111');
              document.getElementById('pdfPreviewer').appendChild(pageMap.get(index));
            }
          });
        }
      });
    },
  }

});
